export enum UserEvent {
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  LOGIN_CANCELED = 'LOGIN_CANCELED'
}
